import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { translation } from '../../../../utils/helpers'

// Components
import ReferencedFrom from '../ReferencedFrom'
import ReferenceOrderData from '../ReferenceOrderData'
import ReferenceExtent from '../ReferenceExtent'
import ReferenceActions from '../ReferenceActions'

// Elements
import Col from '../../../elements/col'
import ReferenceContactInfo from '../ReferenceContactInfo'
import { ReferenceIcons } from '../../../elements/icons'
import Inline from '../../../elements/inline'

class ReferenceApproval extends Component {
  constructor (props) {
    super(props)

    this.state = {
      view: 0
    }

    this.renderPaint = this.renderPaint.bind(this)
    this.renderBodyShop = this.renderBodyShop.bind(this)
  }

  componentDidMount () {
    this.setState({
      view: this.props.department
    })
  }

  renderDivider () {
    return (
      <div className='refOrderApproval__divider' />
    )
  }

  renderPaint () {
    const { referenceInfo, department, onClose, setBottomBarProps } = this.props
    const customer = referenceInfo.Customer

    const actionSection = <ReferenceActions referenceInfo={referenceInfo} onClose={onClose} setBottomBarProps={setBottomBarProps} department={department} isApproval />
    const extent = <ReferenceExtent orderId={referenceInfo.OrderInfo.Orderid} department={department} />
    const customerInfo = <ReferenceContactInfo title={translation('58')} icon={ReferenceIcons.Customer} name={customer.Name} address={customer.Address} phone={customer.Phone} />

    const largeScreen = this.props.dimensionShow([[900, 10000]])
    const smallScreen = this.props.dimensionShow([[0, 700]])

    const column1 = () => {
      return (
        <Col>
          <ReferencedFrom referenceInfo={referenceInfo} department={department} />
          <ReferenceOrderData referenceInfo={referenceInfo} department={department} isApproval />
          {smallScreen && extent}
          {!largeScreen && customerInfo}
          {!largeScreen && actionSection}
        </Col>
      )
    }

    const column2 = () => {
      return (
        <Col>
          {extent}
        </Col>
      )
    }

    const column3 = () => {
      return (
        <Col>
          {customerInfo}
          {actionSection}
        </Col>
      )
    }

    return (
      <div className='refOrderApproval__content'>
        {column1()}
        {!smallScreen && this.renderDivider()}
        {!smallScreen && column2()}
        {largeScreen && this.renderDivider()}
        {largeScreen && column3()}
      </div>
    )
  }

  renderBodyShop () {
    const { referenceInfo, department, onClose, setBottomBarProps } = this.props
    const originalCompany = referenceInfo.OriginalCompany
    const customer = referenceInfo.Customer

    const actionSection = <ReferenceActions referenceInfo={referenceInfo} onClose={onClose} setBottomBarProps={setBottomBarProps} department={department} isApproval />
    const extent = <ReferenceExtent orderId={referenceInfo.OrderInfo.Orderid} department={department} />
    const originalCompanyInfo = <ReferenceContactInfo title={translation('17865')} name={originalCompany.Name} address={originalCompany.Address} phone={originalCompany.Phone} />
    const customerInfo = <ReferenceContactInfo title={translation('58')} name={customer.Name} address={customer.Address} phone={customer.Phone} onlyName />

    const largeScreen = this.props.dimensionShow([[900, 10000]])
    const smallScreen = this.props.dimensionShow([[0, 700]])

    const column1 = () => {
      return (
        <div>
          <ReferencedFrom referenceInfo={referenceInfo} />
          {originalCompanyInfo}
          {customerInfo}
          {!largeScreen && column3()}
          {smallScreen && column2()}
        </div>
      )
    }

    const column2 = () => {
      return (
        <div>
          <ReferenceOrderData referenceInfo={referenceInfo} department={department} isApproval />
          {actionSection}
        </div>
      )
    }

    const column3 = () => {
      return (
        <div>
          {extent}
          <Inline fillChildNum={[0, 1]} block>
            <span>{translation('418')}:</span>
            <span>{referenceInfo.InsuranceCompany}</span>
          </Inline>
        </div>
      )
    }

    return (
      <div className='refOrderApproval__content'>
        <Col>{column1()}</Col>
        {!smallScreen && this.renderDivider()}
        {!smallScreen && <Col>{column2()}</Col>}
        {largeScreen && this.renderDivider()}
        {largeScreen && <Col>{column3()}</Col>}
      </div>
    )
  }

  render () {
    const { view } = this.state

    switch (view) {
      default:
      case 0: // Paint
        return this.renderPaint()
      case 1: // Bodyshop
        return this.renderBodyShop()
    }
  }
}

ReferenceApproval.propTypes = {
  referenceInfo: PropTypes.object.isRequired,
  department: PropTypes.number.isRequired,
  dimensionShow: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}

export default ReferenceApproval



// WEBPACK FOOTER //
// ./src/app/shared/modals/ReferenceOrderActionModal/ReferenceApproval/index.js